import { Component } from '@verndale/core';
import $ from 'jquery';
import AOS from 'aos';
import 'slick-carousel/slick/slick';
import 'bootstrap/js/dist/dropdown';

class MarinasServices extends Component {
  setupDefaults() {
    this.dom = {
      btnReadMore: this.el.querySelectorAll('.btn_readmore')
    };
    AOS.init();
    this.initSlider();
    this.sliderHandler();
  }

  addListeners() {
    this.dom.btnReadMore.forEach(btn => {
      btn.addEventListener('click', () => this.readmore(btn));
    });
  }

  initSlider() {
    const $servicesSlider = $('.services-slider-block .slides');
    $servicesSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 0,
      autoplay: false,
      dots: true,
      pauseOnHover: false,
      waitForAnimate: true,
      arrows: false,
      customPaging (slider, i) {
        const thumb = $(slider.$slides[i]).find('.slider-nav');
        return thumb;
      },
      appendDots: $('.slide-btns')
    });
  }

  sliderHandler() {
    $('#select-services-btn').html(
      $('.services-slider-block .slider-nav')[1].innerHTML
    );
    $('.services-slider-block .slider-nav').on('click', function () {
      $('#select-services-btn').html($(this).html());
    });

    $('.services-slider-block .slider-text').each(function () {
      const $this = $(this);
      const sliderTextHtml = $this.text().replace(/ /g, '');
      const readMore = $this.prev();
      console.log(sliderTextHtml.length);

      if ($(window).width() >= 767) {
        if (sliderTextHtml.length <= 110) {
          readMore.hide();
        }
      } else if (sliderTextHtml.length <= 288) {
          readMore.hide();
        }
    });
  }

  readmore(e) {
    $(e).parent().parent().toggleClass('show-details');

    if ($(e).html() === 'Read less') {
      $(e).html('Read more');
    } else {
      $(e).html('Read less');
    }
  }
}

export default MarinasServices;
